import { statsOnWidgetInteraction } from '../stats';

export function hotpoints() {
  if (document.querySelectorAll('.hotpoints').length) {
    document.querySelectorAll('.hotpoints').forEach((slider) => {

        const mobileDescWrapper = document.createElement('div');
              mobileDescWrapper.classList.add('hotpoints__mobile');
        const mobileDesc = document.createElement('div')
              mobileDesc.classList.add('hotpoints__txt');        
              mobileDescWrapper.append(mobileDesc);
        slider.append(mobileDescWrapper);

      const firstPin = slider.querySelectorAll('.hotpoints__poi')[0];

      mobileDesc.innerHTML = firstPin.querySelector('.hotpoints__poi_txt').innerHTML;

      firstPin.classList.add('__jsActive');
      slider.querySelectorAll('.hotpoints__poi').forEach((pin) => {
        
        if (Number(pin.getAttribute('data-position-left')) > 70) {
            pin.querySelector('.hotpoints__poi_txt').classList.add('__left');
        }
        if (Number(pin.getAttribute('data-position-left')) < 30) {
          pin.querySelector('.hotpoints__poi_txt').classList.add('__right');
        }
        if (Number(pin.getAttribute('data-position-top')) < 50) {
          pin.querySelector('.hotpoints__poi_txt').classList.add('__up');
        }
        if (Number(pin.getAttribute('data-position-top')) >= 50) {
            pin.querySelector('.hotpoints__poi_txt').classList.add('__down');
        }

        pin.style.top = `${pin.getAttribute('data-position-top')}%`;
        pin.style.left = `${pin.getAttribute('data-position-left')}%`;
        pin.addEventListener('mouseenter', () => {
          slider.querySelectorAll('.hotpoints__poi').forEach((el) => {
            el.classList.remove('__jsActive');
          });

          mobileDesc.innerHTML = pin.querySelector('.hotpoints__poi_txt').innerHTML;
          pin.classList.add('__jsActive');

          statsOnWidgetInteraction(
            pin,
            pin.querySelector('.hotpoints__poi_txt').innerText
          );
        });

        pin.addEventListener('mouseleave', () => {
          pin.classList.remove('__jsActive');
          mobileDesc.innerHTML = '';
        });
      });
    });
  }
}
